import ZJApp from '../../../../app'

let utils = ZJApp.ZJUtils;
let ZJApi = ZJApp.ZJApis.ZJApi;

const info = {
    service: 'AlarmService',
    controller: 'AlertInfo'
};

const methods = [
    'AddItem',
    'UpdateItem',
    // 'DelItem',
    // 'DelItemList',
    'GetItemById',
    'GetAlertItemPagingList'
];

const factory = (Fun)=>{
    utils.extend(Fun.prototype, info)
    methods.forEach(path => {
        Fun.prototype[path] = function(data) {
            return this.post(path, data)
        }
    })
};

const AlarmApi = ZJApi.defineNewApi('AlarmApi', factory);

export default AlarmApi;